import { render, staticRenderFns } from "./PaymentCancellationConfirm.vue?vue&type=template&id=225f9194&scoped=true&"
import script from "./PaymentCancellationConfirm.vue?vue&type=script&lang=ts&"
export * from "./PaymentCancellationConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentCancellationConfirm.vue?vue&type=style&index=0&id=225f9194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225f9194",
  null
  
)

export default component.exports